module.exports = __webpack_public_path__ + "static/media/graphql.e70025e8.svg";